import React from "react";
import { matchPath } from "react-router";
import {
  MULTI_QUESTION_LOGIC_JUMP_TYPES,
  MULTI_QUESTION_TYPES,
} from "../../../../../api/questionnaires/config";
import { isNullish } from "../../../../../utilities/general";
import {
  INITIAL_LOGIC_JUMPS,
  OPINION_SCALE_CHOICES,
  QUESTION_TYPES_WITH_LOGIC_JUMPS,
  YES_NO_CHOICES,
} from "./config";

export function getNextInitialChoicesByQuestionType(questionType) {
  switch (questionType) {
    case MULTI_QUESTION_TYPES.yesNo:
      return YES_NO_CHOICES;
    case MULTI_QUESTION_TYPES.opinionScale:
      return OPINION_SCALE_CHOICES;
    default:
      return [];
  }
}

export function getNextInitialLogicJumpsByQuestionType(questionType) {
  return QUESTION_TYPES_WITH_LOGIC_JUMPS.includes(questionType)
    ? INITIAL_LOGIC_JUMPS
    : [];
}

export function getIsSomeLogicJumpsFilled(nodes = []) {
  return nodes.some(
    (node) =>
      !isNullish(node.ifSelectedChoiceId) ||
      !isNullish(node.thenQuestionId) ||
      !isNullish(node.elseQuestionId),
  );
}

export function getIsAllLogicJumpsFilled(nodes) {
  const jumpNodes = nodes.filter(
    (n) => n.type === MULTI_QUESTION_LOGIC_JUMP_TYPES.jump,
  );
  const elseNodes = nodes.filter(
    (n) => n.type === MULTI_QUESTION_LOGIC_JUMP_TYPES.else,
  );
  const isAllJumpNodesFilled = jumpNodes.every(
    (n) => !isNullish(n.ifSelectedChoiceId) && !isNullish(n.thenQuestionId),
  );
  const isAllElseNodesFilled = elseNodes.every(
    (n) => !isNullish(n.elseQuestionId),
  );
  return isAllJumpNodesFilled && isAllElseNodesFilled;
}

export function getQuestionIdsWithUnfinishedLogicJumps(questions = []) {
  return questions.reduce((carry, question) => {
    const logicJumps = question?.logicJumps || [];

    if (
      getIsSomeLogicJumpsFilled(logicJumps) &&
      !getIsAllLogicJumpsFilled(logicJumps)
    ) {
      return [...carry, question.id];
    }

    return carry;
  }, []);
}

export function findLogicJumpsByQuestionId({ questions, questionId }) {
  const result = [];

  for (let q = 0; q < questions.length; q++) {
    const question = questions[q];

    if (question?.logicJumps?.length) {
      for (let j = 0; j < question.logicJumps.length; j++) {
        const jump = question.logicJumps[j];

        if (jump.thenQuestionId === questionId) {
          result.push({
            questionIndex: q,
            logicJumpIndex: j,
            logicJumpField: "thenQuestionId",
          });
        }

        if (jump.elseQuestionId === questionId) {
          result.push({
            questionIndex: q,
            logicJumpIndex: j,
            logicJumpField: "elseQuestionId",
          });
        }
      }
    }
  }

  return result;
}

export const withPathParams = (route, idKey) => (Component) => (props) => {
  const match = matchPath(window.location.pathname, {
    path: route,
    exact: true,
    strict: false,
  });

  const questionnaireId = match?.params?.[idKey]
    ? Number(match.params[idKey])
    : null;

  return <Component {...props} questionnaireId={questionnaireId} />;
};
